import PriceContainer from './PriceContainer';

export default PriceContainer;
